import { addAccessToken, removeAccessToken } from "../constants/userConstant";

export const AddAccessToken = (details) => {
  return {
    type: addAccessToken,
    payload: {
      access_token: details,
    },
  };
};
export const RemoveAccessToken = () => {
  return {
    type: removeAccessToken,
  };
};
